var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrievanceSummaryTotalGrievance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 27.2501H7C6.33696 27.2501 5.70108 26.9866 5.23224 26.5177C4.76338 26.049 4.5 25.413 4.5 24.75V5.50001C4.5 4.83696 4.76338 4.20108 5.23224 3.73224C5.70108 3.26338 6.33696 3 7 3H18.2501L24.5 9.25V10.5",
    stroke: "#707494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 24.3333H19.5084M19.5 17.6667V21M19.5 28.5C23.6421 28.5 27 25.1421 27 21C27 16.8579 23.6421 13.5 19.5 13.5C15.3579 13.5 12 16.8579 12 21C12 25.1421 15.3579 28.5 19.5 28.5Z",
    stroke: "#707494",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrievanceSummaryTotalGrievance);
export default __webpack_public_path__ + "static/media/grievance_summary_total_grievance.e55a908b5ce61cbeaf6cb0a08ac92f0e.svg";
export { ForwardRef as ReactComponent };